<template>
  <input v-if="includeFormFields" type="hidden" name="diary_date" v-model="date">
  <input v-if="includeFormFields" type="hidden" name="diary_date_keep_current" v-model="keep_current">

  <div v-if="!enableDatePicker" class="mb-1 form-control text-center form-control-plaintext">
    <i class="fa fa-calendar"></i> {{ dateOutput }}
  </div>
  <div v-else class="mb-1">
    <datepicker
      v-model="newDate"
      ref="datepicker"
      :min-date="minDate"
      :disabled="!enableDatePicker"
      @closed="selectDate()"
      placeholder="Select a date">
    </datepicker>
  </div>

  <div class="btn-group btn-group-sm d-flex" role="group" data-toggle="buttons">
    <button class="btn btn-info btn-sm" @click.prevent="setKeepCurrent()">
      <input type="radio" name="days"> Keep current
    </button>
    <button v-for="days in dayOptions" class="btn btn-info btn-sm" @click.prevent="addDays(days)">
      <input type="radio" name="days"> {{ days }}d
    </button>
    <button class="btn btn-info btn-sm" @click.prevent="activateDatePicker()">
      <input type="radio" name="days"> Other
    </button>
  </div>
</template>

<script>
const DATE_FORMAT = 'MM/DD/YYYY';

export default {
  emits: ['update:modelValue'],

  props: {
    modelValue: {
      type: [Date, String, Number, Array],
      default: null
    },
    includeFormFields: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      initial: this.modelValue,
      date: this.modelValue,
      keep_current: true,
      dayOptions: [7, 14, 21, 30, 45, 60],
      newDate: this.modelValue,
      enableDatePicker: false,
    }
  },
  methods: {
    setDate(date) {
      if (date) {
        this.date = moment(date, DATE_FORMAT).format(DATE_FORMAT);
        this.newDate = date;
        this.enableDatePicker = false;
        this.keep_current = false;
      }
    },
    selectDate() {
      this.setDate(this.newDate);
    },
    addDays(days) {
      var calculatedDate = moment(new Date()).add(days, 'days').format(DATE_FORMAT);
      this.setDate(calculatedDate);
      this.enableDatePicker = false;
    },
    activateDatePicker() {
      this.enableDatePicker = true;
      this.$nextTick(function () {
        this.$refs.datepicker.openMenu();
      });
    },
    setKeepCurrent() {
      this.keep_current = true;
      this.newDate = this.initial;
      this.date = this.initial;
    },
  },
  computed: {
    dateOutput: function () {
      return this.newDate ? this.newDate : 'Not Set';
    },
    minDate() {
      return moment(new Date()).set({hour: 0, minute: 0, second: 0, millisecond: 0}).format(DATE_FORMAT);
    }
  },
  watch: {
    modelValue: {
      handler(val) {
        this.date = val;
      },
      deep: true
    },

    date: {
      handler(val) {
        if (typeof val === 'object') val = moment(val).format(DATE_FORMAT);
        this.$emit('update:modelValue', val);
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.btn:focus, .btn.focus {
  outline: none;
}

[data-toggle=buttons] > .btn input[type=radio], [data-toggle=buttons] > .btn-static input[type=radio], [data-toggle=buttons] > .btn input[type=checkbox], [data-toggle=buttons] > .btn-static input[type=checkbox], [data-toggle=buttons] > .btn-group > .btn input[type=radio], [data-toggle=buttons] > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
</style>
